<style>
    .approveform textarea.ivu-input{
        font-size: 12px;
    }
    .approveform .ivu-radio-wrapper{
        padding: 0px;
    }
</style>
<template>
    <div>
        <Form
            :model="formData"
            ref="validForm"
            class="approveform"
            :rules="rules"
            :labelWidth="180">
            <FormItem label="Scheduled Delivery Time" style="margin-bottom:10px">
                <div> {{params.startTime}} - {{params.endTime}}</div>
            </FormItem>   
            <FormItem label="Scheduled Delivery Date" prop="reserveInboundDate">
                <RadioGroup v-model="formData.reserveInboundDate" >
                    <Radio :label="params.clientRequestDate">
                        <span class="font-12">Delivery Date: {{params.clientRequestDate}}</span>
                    </Radio>
                    <Radio :label="params.secondClientRequestDate">
                        <span class="font-12">Second Delivery Date: {{params.secondClientRequestDate}}</span>
                    </Radio>
                </RadioGroup>
            </FormItem>    
            <FormItem label="Loading Dock">
                <Input v-model="formData.loadingDock"></Input>
            </FormItem>
            <FormItem label="Remark">
                <Input type="textarea" v-model="formData.approvalRemark"></Input>
            </FormItem>
        </Form>
        <div class="text-right">
            <Button type="primary" @click="submit">确定</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import { HttpApprovedBespeak} from "@/service/bespeak";
export default {
    props:['params'],
    data(){
        return {
            rules: {
                reserveInboundDate: [
                    {
                        required: true,
                        message: "该项不能为空，请填写",
                    },
                ],
            },
            loading:false,
            formData:{},
        }
    },
    methods:{
        async submit(){
            let flag = true;
            await this.$refs.validForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            this.loading = true;
            HttpApprovedBespeak({
                id:this.params.id,
                orgRoleName:this.params.orgRoleName,
                ...this.formData,

            }).then(res=>{
                this.$Message.success(res.message);
                this.loading = false;
                this.$emit('on-update');
                this.cancel();

            },err=>{
                this.loading = false;
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>